import { axiosInstance } from "./AxiosDefaults";
import { ownershipDocumentsRoute } from "../constants/ApiRoutes";
import { OwnershipDocument } from "../models/OwnershipDocument";

export type ApiResponse<T> = {
  status?: "SUCCESS" | "ERROR";
  message?: string;
  result?: T;
};

export const getAllOwnershipDocuments = () => {
  return axiosInstance.get<ApiResponse<OwnershipDocument[]>>(
    ownershipDocumentsRoute,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const getOneOwnershipDocument = (id: string) => {
  return axiosInstance.get<ApiResponse<OwnershipDocument>>(
    `${ownershipDocumentsRoute}/${id}`,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const createOwnershipDocument = (
  payload: Partial<OwnershipDocument>
) => {
  return axiosInstance.post<ApiResponse<OwnershipDocument>>(
    ownershipDocumentsRoute,
    payload,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const updateOneOwnershipDocument = (
  id: string,
  payload: Partial<OwnershipDocument>
) => {
  return axiosInstance.put<ApiResponse<OwnershipDocument>>(
    `${ownershipDocumentsRoute}/${id}`,
    payload,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const deleteOneOwnershipDocument = (id: string) => {
  return axiosInstance.delete<ApiResponse<any>>(
    `${ownershipDocumentsRoute}/${id}`,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};
